<template>
  <div id="accountSwitchedPageWrapper" class="page" refs="accountSwitchedPage">
    <div id="accountSwitchedPageDefault">
      <el-row class="hp-row content-default" type="flex">
        <el-col class="center">
          <div :class="['gradient-card', 'default', { 'plain-card': $utils.isPageForLicenses() }]">
            <div class="header">
              <h4 class="title"></h4>
            </div>
            <div v-if="currentAccountName" class="body">
              <div class="icon"></div>

              <div class="text-wrapper">
                <div class="account-switched">{{$t('switchedAccount.text1')}}</div>
                <div class="account-name">
                  <div class="base">
                  <div class="text">{{$t('switchedAccount.text2', { account: currentAccountName })}}</div>
                  </div>
                  <div class="cover" @mouseover="handleAccountNameHover($event, 'mouseover')" @mouseout="handleAccountNameHover($event, 'mouseout')"></div>
                </div>
              </div>

              <el-button class="cstm-btn-white" @click="handleContinueClick">{{$t('label.continue')}}</el-button>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script src="./account-switched.js"></script>
<style lang="scss" src="./account-switched.scss"></style>
